var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailboxHoverInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_4289_13717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.0905091 1.26486C1.00465 1.87354 1.85544 2.44148 2.70622 3.00943C4.42137 4.1521 6.13652 5.29478 7.8494 6.43746C8.60515 6.94205 9.38353 6.94883 10.1393 6.44651C12.6283 4.79019 15.115 3.12935 17.604 1.47077C17.6877 1.41646 17.7715 1.3599 17.9095 1.26939C17.9434 1.54544 17.9955 1.78529 17.9977 2.02514C18.0045 4.12721 18.0023 6.22929 18.0023 8.33362C18.0023 9.17083 18.0023 10.008 18.0023 10.8453C18 12.0377 17.1741 12.8613 15.9794 12.8613C11.3272 12.8613 6.67278 12.8613 2.02062 12.8613C0.825896 12.8591 0 12.0309 0 10.8362C0 7.89692 0 4.95763 0.00452546 2.01835C0.00452546 1.78303 0.0565682 1.5477 0.0905091 1.26486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.948242 0.285104C1.28765 0.0791955 1.6248 0 1.98457 0C3.58432 0 5.18407 0 6.78382 0C9.8566 0 12.9271 0 15.9999 0C16.3665 0 16.7127 0.0701446 17.0589 0.278316C16.9842 0.330358 16.9276 0.37335 16.8688 0.411816C14.4205 2.04551 11.9723 3.67693 9.52398 5.31062C9.08954 5.60025 8.91757 5.60025 8.48765 5.31288C6.03712 3.6792 3.58885 2.04777 1.14057 0.414079C1.08627 0.377876 1.0297 0.339409 0.948242 0.282841V0.285104Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4289_13717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12.8613,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailboxHoverInactive);
export default __webpack_public_path__ + "static/media/mailboxHoverInactive.3499492a6ababf4c0c01b4211b6ba429.svg";
export { ForwardRef as ReactComponent };